import React, { useState } from "react";
import "./InventoryContent.scss";
import InventoryCreateModal from "./InventoryCreateModal";
import InventoryDetailsModal from "./InventoryDetailsModal";
import InventoryTable from "./InventoryTable";
import { InventoryService } from "../../../../network/InventoryService";
import { useNotification } from "../../../../../Notifications/NotificationProvider";

const InventoryContent = ({
  showInventoryCreateModal,
  setShowInventoryCreateModal,
  searchText,
  onCreateInventory,
}) => {
  const [inventoryListKey, setInventoryListKey] = useState(0);
  const [showDetailsModal, setShowDetailsModal] = useState(false);
  const [selectedInventory, setSelectedInventory] = useState(null);
  const dispatchNotification = useNotification();

  const handleInventoryCreated = () => {
    setInventoryListKey((prev) => prev + 1);
    if (onCreateInventory) {
      onCreateInventory();
    }
  };

  const handleInventorySelect = (inventory) => {
    setSelectedInventory(inventory);
    setShowDetailsModal(true);
  };

  const handleDeactivateInventory = async (inventoryId) => {
    try {
      const response = await InventoryService.deactivateInventory(inventoryId);

      if (response.is_error === 0) {
        dispatchNotification({
          type: "SUCCESS",
          message: "Inventory deactivated successfully!",
        });

        setInventoryListKey((prev) => prev + 1);
      } else {
        throw new Error(response.message || "Failed to deactivate inventory");
      }
    } catch (error) {
      console.error("Error deactivating inventory:", error);

      let errorMessage = "Failed to deactivate inventory. Please try again.";

      if (error.response?.data?.message) {
        errorMessage = error.response.data.message;
      }

      dispatchNotification({
        type: "ERROR",
        message: errorMessage,
      });

      throw error;
    }
  };

  return (
    <div className="inventory-content-container">
      <InventoryTable
        key={inventoryListKey}
        searchText={searchText}
        setShowInventoryCreateModal={setShowInventoryCreateModal}
        onInventorySelect={handleInventorySelect}
      />

      <InventoryCreateModal
        showInventoryCreateModal={showInventoryCreateModal}
        setShowInventoryCreateModal={setShowInventoryCreateModal}
        onInventoryCreated={handleInventoryCreated}
      />

      {showDetailsModal && selectedInventory && (
        <InventoryDetailsModal
          show={showDetailsModal}
          onClose={() => setShowDetailsModal(false)}
          inventory={selectedInventory}
          onDeactivate={handleDeactivateInventory}
        />
      )}
    </div>
  );
};

export default InventoryContent;
